const map = () =>{

    let mapBlock = document.querySelector('#map');
    
    if(mapBlock) {
        ymaps.ready(init);

        function init () {
            var myMap = new ymaps.Map("map", {
                    center: [58.075148, 34.270665],
                    zoom: 5
                }),
                spb = new ymaps.Placemark([59.897533, 30.371600], {
                    // Чтобы балун и хинт открывались на метке, необходимо задать ей определенные свойства.
                    // balloonContentHeader: "Балун метки",
                    balloonContentBody: `<div class="baloone-content-wrap">
                                            <div class="contacts-item">
                                                <div class="contacts-title">Адрес:</div>
                                                <div class="name-street">Санкт-Петербург, ул. Магнитогорская, д. 23, к. 1</div>
                                            </div>
                                            <div class="contacts-item">
                                                <span class="contacts-title">Режим работы:</span>
                                                <span class="desc">Пн-Пт 9:00 - 18:00</span>
                                            </div>
                                            <div class="contacts-item">
                                                <span class="contacts-title">Телефон:</span>
                                                <a href="tel:88126556736" class="link">+7 (812) 655-67-36</a>
                                            </div>
                                            <div class="contacts-item">
                                                <span class="contacts-title">Email:</span>
                                                <a href="mailto:info@schmetz-needles.ru" class="link desc">info@schmetz-needles.ru</a>
                                            </div>
                                        </div>`,
                    // balloonContentFooter: "Подвал",
                    hintContent: "Санкт-Петербург"
                },
                {
                    // Опции.
                    // Своё изображение иконки метки.
                    // iconImageHref: '../img/icons/placeholder_blue.svg',
                    iconImageHref: 'https://html.knit.team/Shmetz/img/icons/placeholder_blue.svg',
                    // Размеры метки.
                    iconImageSize: [45, 52],
                    // Смещение левого верхнего угла иконки относительно
                    // её "ножки" (точки привязки).
                    iconImageOffset: [-3, -42],
                    balloonOffset: [17, 2]
                });

            var msk = new ymaps.Placemark([55.840902, 37.487397], {
                    // Чтобы балун и хинт открывались на метке, необходимо задать ей определенные свойства.
                    // balloonContentHeader: "Балун метки",
                    balloonContentBody: `<div class="baloone-content-wrap">
                                            <div class="contacts-item">
                                                <div class="contacts-title">Адрес:</div>
                                                <div class="name-street">Москва, Кронштадтский бульвар, д. 7</div>
                                            </div>
                                            <div class="contacts-item">
                                                <span class="contacts-title">Режим работы:</span>
                                                <span class="desc">Пн-Пт 9:00 - 18:00</span>
                                            </div>
                                            <div class="contacts-item">
                                                <span class="contacts-title">Телефон:</span>
                                                <a href="tel:84999410894" class="link">+7 (499) 941-08-94</a>
                                            </div>
                                            <div class="contacts-item">
                                                <span class="contacts-title">Email:</span>
                                                <a href="mailto:info@schmetz-needles.ru" class="link desc">info@schmetz-needles.ru</a>
                                            </div>
                                        </div>`,
                    // balloonContentFooter: "Подвал",
                    hintContent: "Москва",
                    
                },
                {
                    // Опции.
                    // Своё изображение иконки метки.
                    // iconImageHref: '../img/icons/placeholder_blue.svg',
                    iconImageHref: 'https://html.knit.team/Shmetz/img/icons/placeholder_blue.svg',
                    // Размеры метки.
                    iconImageSize: [45, 52],
                    // Смещение левого верхнего угла иконки относительно
                    // её "ножки" (точки привязки).
                    iconImageOffset: [-3, -42],
                    balloonOffset: [17, 2]
                });
            
            myMap.controls
                .add('zoomControl', { left: 5, top: 5 })
                .add('mapTools', { left: 35, top: 5 });

            myMap.behaviors.enable('scrollZoom');
            
            
            myMap.geoObjects.add(spb);
            myMap.geoObjects.add(msk);

        }


        };
    }

export default map;